import PropTypes from "prop-types";

const Toggle = (props) => {
  const { checked, size = "small", label = "", onChange, name = "", value, disabled, onBlur } = props;

  return (
    <div className="flex">
      <label className="flex items-center cursor-pointer">
        <div className="relative">
          <input
            onBlur={onBlur}
            value={value}
            disabled={disabled}
            onChange={onChange}
            name={name}
            type="checkbox"
            checked={checked}
            className="sr-only"
          />

          <div
            style={size === "small" ? { width: 30, height: 16 } : { width: 45, height: 24 }}
            className={`${
              checked ? "bg-blue-hedgehog hover:bg-blue-shark" : "bg-neutral-light border border-gray-spain"
            } block rounded-full`}
          ></div>

          <div
            style={
              size === "small" ? { width: 13, height: 12, left: 2.2, top: 2.1 } : { width: 20, height: 18, left: 2.2, top: 3.1 }
            }
            className={`${checked ? "bg-neutral-light" : "bg-gray-spain"} dot absolute  rounded-full transition }`}
          ></div>
        </div>
      </label>
      {label && <span className="font-semibold ml-2 hover:text-blue-shark">{label}</span>}
    </div>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  size: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default Toggle;
